<template lang="pug">
  .summary
    GenericTable
      tr(slot="thead")
        th Name
        th Count
        th Configuration
        th Type
        th
      tr(v-for="(cd, index) in codeData")
        td {{cd.name}}
        td
          span(v-if="cd.codeCount") {{cd.codeCount}}
          span(v-else) {{cd.codes.length}}
        td
          span(v-if="cd.codeConfiguration && configs") {{getCodeConfigName(cd.codeConfiguration.id).description}}
        td
          span {{cd.type}}
          span(v-if="cd.codeType") - {{cd.codeType}}
        td.actions
          a.fa.fa-times(@click="removeExpansion(index)")
</template>

<script>
import Core from '@/service/apis/Core'
import GenericTable from '@/components/common/GenericTable'

export default {
  props: {
    codeData: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    configs: null
  }),
  created() {
    Core.listCodeConfigs()
      .then((resp) => {
        this.configs = resp.data.content
      })
  },
  methods: {
    getCodeConfigName(id) {
      return this.configs.find((c) => {
        if (id === c.id) {
          return c
        }
        return null
      })
    },
    removeExpansion(index) {
      this.$emit('removeExpansion', index)
    }
  },
  components: {
    GenericTable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/code/components/CodeSummary.vue